'use client';
import { lazy, Suspense, forwardRef, useRef, type ComponentProps, type ComponentRef } from 'react';
import { GenericLoader } from '@eliadmin/core/src/components/ui/generic-loader';
export type * from "/tmp/build-340/node_modules/@eliadmin/core/src/components/suppliers-map/suppliers-map.tsx";

type Props = NonNullable<ComponentProps<typeof import("/tmp/build-340/node_modules/@eliadmin/core/src/components/suppliers-map/suppliers-map.tsx").SuppliersMap>>;
const Deferred = lazy(() => import("@eliadmin/module-original/suppliersMap").then(m => ({ default: m.SuppliersMap })));
export function SuppliersMap(props: Props) {  return <Suspense fallback={<div aria-busy="true" className="flex h-[600px] items-center justify-center"><GenericLoader /></div>}><Deferred {...props} /></Suspense>; }

